import Endpoints from 'constants/Endpoints';
import {RestRequestGET, RestRequestPOST} from 'libs/RestRequest';
import {clearResource, setResource} from 'redux/actions'
import reduxStore from 'redux/store'
import applySearchParams from "libs/applySearchParams";
import validateSection from "./helpers/validateSection";
import {DemandValidation} from "../constants/DemandValidation";

const OFFER_EVALUATION_LIST_RESOURCE_ID = 'offerEvaluationList';

const clearResources = (resource) => {
    reduxStore.dispatch(clearResource(resource));
}

const getOffers = async (demandId, pagination, search, mode, roundType) => {
    const params = {
        ...pagination
    };
    applySearchParams(search, params);
    try {
        const resp = await RestRequestGET(Endpoints.OFFER_EVALUATION_LIST(demandId, mode, roundType), {params});
        //const resp = {...lsit(pagination, search, mode)};
        reduxStore.dispatch(setResource(OFFER_EVALUATION_LIST_RESOURCE_ID, resp));
    } catch (error) {
    }
};

const handleUpdate = async (response, mode, offerItem, rowItem, status) => {
    if (response.success) {
        const result = response.result;
        const changeType = result.changeType;
        const {resources} = reduxStore.getState();

        switch (changeType) {
            case AVAILABLE_CHANGE_TYPES.STATUS:
                const list = resources[OFFER_EVALUATION_LIST_RESOURCE_ID];
                const newList = {
                    ...list,
                    items: list.items.map(offer => {
                        if (offer.identity === offerItem.identity) {
                            offer.offerEvaluations = offer.offerEvaluations.map(row => {
                                if (row.identity === rowItem.identity) {
                                    row.status = status;
                                }
                                return row;
                            })
                        }
                        return offer;
                    })
                }
                reduxStore.dispatch(setResource(OFFER_EVALUATION_LIST_RESOURCE_ID, newList));
                break;
            case AVAILABLE_CHANGE_TYPES.ROW:
                const list2 = resources[OFFER_EVALUATION_LIST_RESOURCE_ID];
                const newList2 = {
                    ...list2,
                    items: list2.items.map(offer => {

                        if (offer.identity === offerItem.identity) {
                            offer.offerEvaluations = offer.offerEvaluations.map(row => {
                                if (row.identity === rowItem.identity) {
                                    return result.offerEvaluation;
                                }
                                return row;
                            })
                        }
                        return offer;
                    })
                }
                reduxStore.dispatch(setResource(OFFER_EVALUATION_LIST_RESOURCE_ID, newList2));
                break;
            case AVAILABLE_CHANGE_TYPES.ALL:
                break;
            default:
                throw new Error("Unsupported change type: " + changeType);
        }

        return changeType;
    }
}

const updateStatus = async (demandId, mode, roundType, offerItem, row, status) => {
    const data = {
        identity: offerItem.identity,
        mode,
        offerEvaluation: {
            identity: row.identity,
            status
        }
    }
    const resp = await RestRequestPOST(Endpoints.OFFER_EVALUATION_LIST_UPDATE_STATUS(demandId, mode, roundType), data);
    await validateSection(DemandValidation.OFFERS_EVALUATION, demandId, false);
    return handleUpdate(resp, mode, offerItem, row, status);
};

const updateScore = async (demandId, mode, roundType, offerItem, row, criterion, score) => {
    const data = {
        identity: offerItem.identity,
        mode,
        offerEvaluation: {
            identity: row.identity,
            criteriaEvaluation: {
                identity: criterion.identity,
                score
            }
        }
    }

    const resp = await RestRequestPOST(Endpoints.OFFER_EVALUATION_LIST_UPDATE_SCORE(demandId, mode, roundType), data);
    await validateSection(DemandValidation.OFFERS_EVALUATION, demandId, false);
    return handleUpdate(resp, mode, offerItem, row);
};


const validate = async (id) => {
    return RestRequestGET(Endpoints.OFFER_EVALUATION_VALIDATE(id));
}

const AVAILABLE_CHANGE_TYPES = {
    STATUS: "STATUS",
    ROW: "ROW",
    ALL: "ALL"
}

export default {
    getOffers,
    updateStatus,
    updateScore,
    validate,
    clearResources,
    OFFER_EVALUATION_LIST_RESOURCE_ID,
    AVAILABLE_CHANGE_TYPES
}